import { render } from "./PatientLookup.vue?vue&type=template&id=3ba78469&scoped=true&ts=true"
import script from "./PatientLookup.vue?vue&type=script&lang=ts"
export * from "./PatientLookup.vue?vue&type=script&lang=ts"

import "./PatientLookup.vue?vue&type=style&index=0&id=3ba78469&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba78469"]])

export default __exports__